import React, { useEffect, useState } from 'react'
import { CardMedia,Card,CardActions,Button ,CardContent,Typography} from '@material-ui/core';
import ReactPlayer from 'react-player'
import Box from "@material-ui/core/Box";
import { makeStyles } from '@material-ui/core/styles';
import {useStyles} from '../MuiCssStyle/MUiStyle'
const wordAccumulator=(word,count)=>{
    const arrayString=[]

    for(let i=0;i<count;i++)
        arrayString.push(word[i])
    return arrayString.join(" ")+"..."

    
}
const limitWord=(text,limitwords)=>{
    const wordSplit= text.split(" ")
    
   return wordSplit.length>limitwords?wordAccumulator(wordSplit,limitwords):text
}
const Helper=({videoURL="",text="",title=""})=>{

    const [expand,setExpand]=useState(false)
    
    const styles=useStyles()
    return <Card  raised={true} className={styles.cardStyle}>
                      
            <Box className={styles.playerStyle}> 
            <figure>
            <ReactPlayer
                        className='react-player'
                        url= {window.location.origin+videoURL}
                        width='480px'
                        height='240px'
                        controls = {true}
                      
                        />
            <figcaption style={{textAlign:"center"}}>{title}</figcaption>
            </figure>
                   
            </Box>
            <Box className={styles.textContainer} > 
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                     {title}
                    </Typography>
                    <Box style={{overflow:"auto",height:"150px"}}>
                    <Typography variant="body2" style={{ color: 'text.secondary'
                     }}>
                                {expand?text:limitWord(text,10)}
                    </Typography>
                    </Box>
                </CardContent>
                <CardActions>
                    <Button size="small" style={{color:"blue"}} onClick={()=>{
                        setExpand((prev)=>!prev)
                    }}
                    className={styles.button}
                
                    >Learn More</Button>
                </CardActions>
                </Box>  
    </Card>
    
}

export default Helper
